import { InboxThreadList, InboxThreadListHeader } from "./components";
import { Navigate, Outlet, useLocation } from "react-router-dom";
import { getInboxView } from "./utils";

export const InboxThreadAndConversationPage = () => {
  const location = useLocation();
  const view = getInboxView(location);

  if (!view) {
    return <Navigate to="/messaging/inbox" />;
  }

  return (
    <div className="flex bg-background h-full w-full overflow-hidden">
      {/* Left Panel - Thread List */}
      <div className="flex flex-col border-r h-full w-[22rem] flex-shrink-0">
        <InboxThreadListHeader />

        <div className="flex-1 flex flex-col overflow-hidden">
          <InboxThreadList />
        </div>
      </div>

      {/* Right Panel - Conversation or Compose - Handled by router */}
      <div className="flex flex-col h-full flex-1 ">
        <Outlet />
      </div>
    </div>
  );
};
